<template>
  <div class="mainContainer blaLoginContainer">
    <MobileApp />
  </div>
</template>

<script>
import MobileApp from '@/views/mobile/App';

export default {
  components: {
    MobileApp
  },
  data: () => ({
    loginShow: false
  }),

  method: () => ({})
};
</script>
